import { Empty } from "./common";

export function DataTable({ columns, rows, onRowClick, testid }) {
  if (!rows.length) return <Empty />;
  return (
    <div className="thin-scroll -mx-5 overflow-x-auto" data-testid={testid}>
      <table className="w-full text-sm">
        <thead>
          <tr className="border-y border-zinc-100 bg-zinc-50/60 text-left">
            {columns.map((c) => (
              <th key={c.key} className="whitespace-nowrap px-5 py-2.5 text-[11px] font-medium uppercase tracking-wider text-zinc-400">{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr
              key={r.id || i}
              data-testid={`${testid}-row-${i}`}
              onClick={onRowClick ? () => onRowClick(r) : undefined}
              className={`border-b border-zinc-100 transition-colors last:border-0 hover:bg-zinc-50/70 ${onRowClick ? "cursor-pointer" : ""}`}
            >
              {columns.map((c) => (
                <td key={c.key} className="px-5 py-3 align-middle text-zinc-700">{c.render ? c.render(r) : r[c.key] || "—"}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
